import React from 'react';
import { Row, Col, Card, Button, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../pages/useAuth';

const actionCards = [
     {
          title: 'On-Duty Doctors',
          description: 'Track live city-wise on-duty Radiologists Doctors list.',
          cta: 'Open Live View',
          route: '/citywise-on-duty-doctors-new',
          tone: '#e8f0fe',
          tag: 'Live'
     },

];

const TeleSupport_Dashboard = () => {
     useAuth();
     const navigate = useNavigate();

     return (
          <div style={{ padding: 24, backgroundColor: '#f7f9fc', minHeight: '100vh' }}>
               <div style={{ maxWidth: 1200, margin: '0 auto' }}>
                    <div style={{ marginBottom: 18 }}>
                         <h4 style={{ marginBottom: 6 }}>Tele Support Workspace</h4>

                    </div>

                    <Row className="g-3">
                         {actionCards.map((action) => (
                              <Col key={action.title} md={6} lg={4}>
                                   <Card style={{ border: '1px solid #e7ebf0', borderRadius: 12, height: '100%', background: action.tone }}>
                                        <Card.Body style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                                             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                  <Card.Title style={{ margin: 0, fontSize: 17 }}>{action.title}</Card.Title>
                                                  <Badge bg="light" text="dark" style={{ border: '1px solid #d7dce2' }}>{action.tag}</Badge>
                                             </div>
                                             <Card.Text style={{ color: '#445065', fontSize: 13, flex: 1, marginBottom: 0 }}>
                                                  {action.description}
                                             </Card.Text>
                                             <Button
                                                  size="sm"
                                                  style={{ alignSelf: 'flex-start' }}
                                                  onClick={() => navigate(action.route)}
                                             >
                                                  {action.cta}
                                             </Button>
                                        </Card.Body>
                                   </Card>
                              </Col>
                         ))}
                    </Row>
               </div>
          </div>
     );
};

export default TeleSupport_Dashboard;
